import { render, staticRenderFns } from "./page25.vue?vue&type=template&id=4d93fa70&scoped=true&"
import script from "./page25.vue?vue&type=script&lang=js&"
export * from "./page25.vue?vue&type=script&lang=js&"
import style0 from "./page25.vue?vue&type=style&index=0&id=4d93fa70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d93fa70",
  null
  
)

export default component.exports